import {
  COLOR_PALETTES,
  RESET_COLOR_PALETTES,
  SET_COMPANY_LOGO,
  SET_COMPANY_ICON,
  RESET_REDUX_STATE
} from "../constants";

const initState = {
  color_palettes: {
    "50": "#ebf3fd",
    "100": "#c5dcfa",
    "200": "#a0c5f7",
    "300": "#7aaef3",
    "400": "#5597f0",
    "500": "#2f80ed",
    "600": "#136be0",
    "700": "#1059ba",
    "800": "#0d4795",
    "900": "#0a356f",
    "950": "#202E56"
  },
  logo: "",
  icon: ""
};

const palettes = (state = initState, action) => {
  const { type, payload } = action;

  switch (type) {
    case COLOR_PALETTES: {
      return {
        ...state,
        color_palettes: payload,
      };
    }

    case SET_COMPANY_LOGO: {
      return {
        ...state,
        logo: payload,
      };
    }

    case RESET_COLOR_PALETTES: {
      return initState;
    }

    case SET_COMPANY_ICON: {
      return {
        ...state,
        icon: payload
      }
    }

    case RESET_REDUX_STATE: {
      return initState;
    }

    default: {
      return state;
    }
  }
};

export default palettes;
